import { useEffect, useState } from 'react';
import {
	activateNews,
	desactivateNews,
	getNews,
	getOlibsLibrariesCodes,
} from '../../Services/news';
import EditIcon from '../../Images/edit-icon.png';
import DeleteIcon from '../../Images/trash-icon.png';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const useNewsPage = () => {
	const [news, setNews] = useState([]);
	const [allLibraries, setAllLibraries] = useState([]);
	const AllLibrariesOption = { label: 'ALL', value: 'ALL' };
	const navigate = useNavigate();

	const handleDesactivateNews = async (newsId) => {
		try {
			await desactivateNews(newsId);
			handleGetNews();
			toast.success('News deactivated');
		} catch (error) {
			toast.error('Error deactivating news');
			console.error('Error deactivating news:', error);
		}
	};

	const handleActivateNews = async (newsId) => {
		try {
			await activateNews(newsId);
			handleGetNews();
			toast.success('News activated');
		} catch (error) {
			toast.error('Error activating news');
			console.error('Error activating news:', error);
		}
	};

	const handleGetOlibLibraries = async () => {
		try {
			const response = await getOlibsLibrariesCodes();

			const responseOptions = response?.data?.map((item) => {
				return {
					value: item,
					label: item,
				};
			});

			setAllLibraries([AllLibrariesOption, ...responseOptions]);
		} catch (error) {
			console.error('Error fetching OLIB libraries:', error);
		}
	};

	const handleGetNews = async (institutionCode) => {
		try {
			const news = await getNews(institutionCode);
			const sorted = news.sort(
				(a, b) => Number(b.is_active) - Number(a.is_active)
			);

			const formatNews = sorted?.map((item) => ({
				id: item.news_id,
				title: item.title,
				active: item.is_active ? 'Active' : 'Inactive',
				institutions: item.institutions,
				actions: (
					<div className='flex items-center gap-x-4'>
						<button
							className='w-[15px]'
							onClick={() => navigate(`/news/${item.news_id}`)}
						>
							<img src={EditIcon} alt='' />{' '}
						</button>
						{item?.is_active && (
							<button
								className='w-[15px]'
								onClick={() => handleDesactivateNews(item?.news_id)}
							>
								<img src={DeleteIcon} alt='Delete' />{' '}
							</button>
						)}

						{item?.is_active === false && (
							<>
								<button
									className='w-[15px]'
									onClick={() => handleActivateNews(item?.news_id)}
								>
									<svg
										stroke='currentColor'
										fill='currentColor'
										stroke-width='0'
										viewBox='0 0 352 512'
										height='15px'
										width='15px'
										xmlns='http://www.w3.org/2000/svg'
									>
										<path d='M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z'></path>
									</svg>
								</button>
							</>
						)}
					</div>
				),
			}));

			setNews(formatNews ? formatNews : []);
		} catch (error) {
			console.error('Error fetching news:', error);
		}
	};

	const handleChangeLibrarySelected = async (library) => {
		try {
			const libraryCode = library === 'ALL' ? '' : library;
			const newsByLibrary = await getNews(libraryCode);
			const sorted = newsByLibrary.sort(
				(a, b) => Number(b.is_active) - Number(a.is_active)
			);

			const formatNews = sorted?.map((item) => ({
				id: item.news_id,
				title: item.title,
				active: item.is_active ? 'Active' : 'Inactive',
				institutions: item.institutions,
				actions: (
					<div className='flex items-center gap-x-4'>
						<button
							className='w-[15px]'
							onClick={() => navigate(`/news/${item.news_id}`)}
						>
							<img src={EditIcon} alt='' />{' '}
						</button>
						{item?.is_active && (
							<button
								className='w-[15px]'
								onClick={() => handleDesactivateNews(item?.news_id)}
							>
								<img src={DeleteIcon} alt='Delete' />{' '}
							</button>
						)}

						{item?.is_active === false && (
							<>
								<button
									className='w-[15px]'
									onClick={() => handleActivateNews(item?.news_id)}
								>
									<svg
										stroke='currentColor'
										fill='currentColor'
										stroke-width='0'
										viewBox='0 0 352 512'
										height='15px'
										width='15px'
										xmlns='http://www.w3.org/2000/svg'
									>
										<path d='M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z'></path>
									</svg>
								</button>
							</>
						)}
					</div>
				),
			}));

			setNews(formatNews);
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		handleGetNews();
		handleGetOlibLibraries();
	}, []);

	useEffect(() => {
		if (!localStorage.name || !localStorage.email) {
			navigate('/');
		}
	}, []);

	return { news, setNews, allLibraries, handleChangeLibrarySelected };
};
